import { render, staticRenderFns } from "./RoundSummary.vue?vue&type=template&id=2ce3a65f&scoped=true&"
import script from "./RoundSummary.vue?vue&type=script&lang=js&"
export * from "./RoundSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3a65f",
  null
  
)

export default component.exports